import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`fixed h-screen w-64 bg-gray-800 text-white flex flex-col justify-between transition-transform transform py-10 shadow-lg ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } md:translate-x-0`}
    >
      <div className="flex flex-col items-center">
        <h2 className="text-center text-2xl font-bold py-4 border-b border-gray-700 w-full">
          Real-Time Notifier
        </h2>
        <ul className="w-full mt-4">
          <li className="px-4 py-2 w-full text-center hover:bg-gray-700 transition duration-200">
            <Link to="/" className="block">
              About
            </Link>
          </li>
          <li className="px-4 py-2 w-full text-center hover:bg-gray-700 transition duration-200">
            <Link to="/how-to-use" className="block">
              How to Use
            </Link>
          </li>
        </ul>
      </div>
      <div className="text-center pb-4">
        <p>Version: 1.0.0</p>
      </div>
      <button
        className="absolute top-4 left-4 md:hidden focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <svg
          className="w-8 h-8 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
      </button>
    </div>
  );
};

export default Navbar;
